<div class="documentation-only--application">
    <div class="ontario-header__container">
        <header class="ontario-application-header ontario-header" id="ontario-header">
            <div class="ontario-row">
                <div class="ontario-columns ontario-small-6 ontario-application-header__logo">
                    <a href="https://www.ontario.ca/page/government-ontario">
                        <img src="../assets/images/ontario.ca.svg" alt="{{ 'link.open.new.window' | translate | async }}" />
                    </a>
                </div>
                <div class="ontario-columns ontario-small-6 ontario-application-header__lang-toggle">
                    <button (click)="switchLanguage()" tabindex="0"
						class="ontario-header__language-toggler ontario-header-button ontario-header-button--without-outline">
						<abbr title="Français" class="ontario-show-for-small-only">
							{{ oppositeLanguage === 'en' ? 'EN' : 'FR' }}
						</abbr>
						<span class="ontario-show-for-medium">
							{{ oppositeLanguage === 'en' ? 'English' : 'Français' }}
						</span>
					</button>
                </div>
            </div>
        </header>
        <div class="ontario-application-subheader-menu__container">
            <section class="ontario-application-subheader">
                <div class="ontario-row">
                    <div class="ontario-columns ontario-small-12 ontario-application-subheader__container">
                        <h1 class="main-title ontario-application-subheader__heading">
							{{ 'geology.ontario' | translate | async }}
                        </h1>

                        <div class="ontario-application-subheader__menu-container">
                            <ul class="ontario-application-subheader__menu ontario-show-for-large ontario-hide-for-small header-items">
                                <li>
                                    <ng-container *ngIf="oppositeLanguage !== 'en'; else ministryOfMinesFr">
                                        <a href="https://www.ontario.ca/page/ministry-mines">
                                            {{ 'ministry.of.mines' | translate | async }}
                                        </a>
                                    </ng-container>
                                    <ng-template #ministryOfMinesFr>
                                        <a href="https://www.ontario.ca/fr/page/ministere-des-mines">
                                            {{ 'ministry.of.mines' | translate | async }}
                                        </a>
                                    </ng-template>
                                </li>
                                <li>
                                    <ng-container *ngIf="oppositeLanguage !== 'en'; else newsFr">
                                        <a href="https://news.ontario.ca/mines/en">
                                            {{ 'news' | translate | async }}
                                        </a>
                                    </ng-container>
                                    <ng-template #newsFr>
                                        <a href="https://news.ontario.ca/mines/fr">
                                            {{ 'news' | translate | async }}
                                        </a>
                                    </ng-template>
                                </li>
                                <li>
                                    <ng-container *ngIf="oppositeLanguage !== 'en'; else helpFr">
                                        <a href="https://storymaps.arcgis.com/stories/0525160764b24e52b96ec08aa7c5eea2">
                                            {{ 'help' | translate | async }}
                                        </a>
                                    </ng-container>
                                    <ng-template #helpFr>
                                        <a href="https://storymaps.arcgis.com/stories/884170a8b8ee460388ac74b27d4edf8f">
                                            {{ 'help' | translate | async }}
                                        </a>
                                    </ng-template>
                                </li>
                                <li>
                                    <ng-container *ngIf="oppositeLanguage !== 'en'; else feedbackFr">
                                        <a href="https://forms.office.com/Pages/ResponsePage.aspx?id=KRLczSqsl0u3ig5crLWGXH9f41tadDtMo9x4Env469ZUMzY1QVBYM1ZYREtHMFZIUkZQQUUxVVVNRCQlQCN0PWcu&lang=en-US">
                                            {{ 'feedback' | translate | async }}
                                        </a>
                                    </ng-container>
                                    <ng-template #feedbackFr>
                                        <a href="https://forms.office.com/Pages/ResponsePage.aspx?id=KRLczSqsl0u3ig5crLWGXH9f41tadDtMo9x4Env469ZUMzY1QVBYM1ZYREtHMFZIUkZQQUUxVVVNRCQlQCN0PWcu&lang=fr-CA">
                                            {{ 'feedback' | translate | async }}
                                        </a>
                                    </ng-template>
                                </li>
                            </ul>

                            <button class="ontario-header__menu-toggler ontario-header-button ontario-header-button--with-outline ontario-hide-for-large ontario-show-for-small" id="ontario-header-menu-toggler" aria-controls="ontario-navigation" aria-label="open menu" type="button">
                                <svg class="ontario-icon" focusable="false" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                                    <use xlink:href="#ontario-icon-menu"></use>
                                </svg>
								<span>{{ 'home.topnav.sidenav.menu.title' | translate | async }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </section>
            <nav class="ontario-navigation" id="ontario-navigation">
                <button class="ontario-header__menu-toggler ontario-header-button ontario-header-button--with-outline" id="ontario-header-nav-toggler" aria-controls="ontario-navigation" aria-label="close">
                    <svg class="ontario-icon" focusable="false" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                        <use xlink:href="#ontario-icon-close"></use>
                    </svg>
					<span>{{ 'home.topnav.sidenav.menu.title' | translate | async }}</span>
                </button>
                <div class="ontario-navigation__container">
                    <ul>
                        <li>
                            <ng-container *ngIf="oppositeLanguage !== 'en'; else ministryOfMinesFr">
                                <a href="https://www.ontario.ca/page/ministry-mines">
                                    {{ 'ministry.of.mines' | translate | async }}
                                </a>
                            </ng-container>
                            <ng-template #ministryOfMinesFr>
                                <a href="https://www.ontario.ca/fr/page/ministere-des-mines">
                                    {{ 'ministry.of.mines' | translate | async }}
                                </a>
                            </ng-template>
                        </li>
                        <li>
                            <ng-container *ngIf="oppositeLanguage !== 'en'; else newsFr">
                                <a href="https://news.ontario.ca/mines/en">
                                    {{ 'news' | translate | async }}
                                </a>
                            </ng-container>
                            <ng-template #newsFr>
                                <a href="https://news.ontario.ca/mines/fr">
                                    {{ 'news' | translate | async }}
                                </a>
                            </ng-template>
                        </li>
                        <li>
                            <ng-container *ngIf="oppositeLanguage !== 'en'; else helpFr">
                                <a href="https://storymaps.arcgis.com/stories/0525160764b24e52b96ec08aa7c5eea2">
                                    {{ 'help' | translate | async }}
                                </a>
                            </ng-container>
                            <ng-template #helpFr>
                                <a href="https://storymaps.arcgis.com/stories/884170a8b8ee460388ac74b27d4edf8f">
                                    {{ 'help' | translate | async }}
                                </a>
                            </ng-template>
                        </li>
                        <li>
                            <ng-container *ngIf="oppositeLanguage !== 'en'; else feedbackFr">
                                <a href="https://forms.office.com/Pages/ResponsePage.aspx?id=KRLczSqsl0u3ig5crLWGXH9f41tadDtMo9x4Env469ZUMzY1QVBYM1ZYREtHMFZIUkZQQUUxVVVNRCQlQCN0PWcu&lang=en-US">
                                    {{ 'feedback' | translate | async }}
                                </a>
                            </ng-container>
                            <ng-template #feedbackFr>
                                <a href="https://forms.office.com/Pages/ResponsePage.aspx?id=KRLczSqsl0u3ig5crLWGXH9f41tadDtMo9x4Env469ZUMzY1QVBYM1ZYREtHMFZIUkZQQUUxVVVNRCQlQCN0PWcu&lang=fr-CA">
                                    {{ 'feedback' | translate | async }}
                                </a>
                            </ng-template>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    </div>
    <div class="ontario-overlay"></div>
</div>